(() => {
  const initGuides = (scope = document) => {
    const guides = scope.querySelectorAll("[data-rf-how-guide]");
    guides.forEach((guide) => {
      if (guide.dataset.rfHowBound === "true") return;
      guide.dataset.rfHowBound = "true";

      const steps = Array.from(guide.querySelectorAll("[data-rf-how-step]"));
      const prevBtn = guide.querySelector("[data-rf-how-prev]");
      const nextBtn = guide.querySelector("[data-rf-how-next]");
      const mediaRoot = guide.closest(".rf-how__grid")?.querySelector("[data-rf-how-media]");
      const mediaStates = mediaRoot ? Array.from(mediaRoot.querySelectorAll("[data-rf-how-media-index]")) : [];

      if (!steps.length) return;

      let activeIndex = Math.max(
        0,
        steps.findIndex((step) => step.classList.contains("is-active"))
      );
      let isAnimating = false;
      let queuedIndex = null;
      const CLOSE_FIRST_DELAY_MS = 220;
      const MEDIA_FADE_MS = 320;

      const updateControls = (currentIndex) => {
        if (prevBtn) {
          const isDisabled = currentIndex === 0;
          prevBtn.disabled = isDisabled;
          prevBtn.setAttribute("aria-disabled", isDisabled ? "true" : "false");
        }

        if (nextBtn) {
          const isDisabled = currentIndex === steps.length - 1;
          nextBtn.disabled = isDisabled;
          nextBtn.setAttribute("aria-disabled", isDisabled ? "true" : "false");
        }
      };

      const closeAllText = () => {
        steps.forEach((step) => {
          step.classList.remove("is-active");
          step.setAttribute("aria-expanded", "false");
        });
      };

      const openTextAt = (indexToOpen) => {
        steps.forEach((step, index) => {
          const isActive = index === indexToOpen;
          step.classList.toggle("is-active", isActive);
          step.setAttribute("aria-expanded", isActive ? "true" : "false");
        });
      };

      const setMediaAt = (indexToOpen) => {
        mediaStates.forEach((panel, index) => {
          const isActive = index === indexToOpen;
          panel.classList.toggle("is-active", isActive);
          panel.classList.remove("is-entering");
          panel.setAttribute("aria-hidden", isActive ? "false" : "true");
        });
      };

      const crossfadeMedia = (fromIndex, toIndex) => {
        if (!mediaStates.length || fromIndex === toIndex) return;

        const fromPanel = mediaStates[fromIndex];
        const toPanel = mediaStates[toIndex];
        if (!toPanel) return;

        if (fromPanel) {
          fromPanel.classList.add("is-active");
          fromPanel.classList.remove("is-entering");
          fromPanel.setAttribute("aria-hidden", "false");
        }

        toPanel.classList.add("is-entering");
        toPanel.classList.remove("is-active");
        toPanel.setAttribute("aria-hidden", "false");

        requestAnimationFrame(() => {
          toPanel.classList.add("is-active");
        });

        window.setTimeout(() => {
          if (fromPanel && fromPanel !== toPanel) {
            fromPanel.classList.remove("is-active");
            fromPanel.classList.remove("is-entering");
            fromPanel.setAttribute("aria-hidden", "true");
          }
          toPanel.classList.remove("is-entering");
          toPanel.setAttribute("aria-hidden", "false");
        }, MEDIA_FADE_MS + 30);
      };

      const setActive = (nextIndex, options = {}) => {
        const clamped = Math.max(0, Math.min(nextIndex, steps.length - 1));
        if (clamped === activeIndex && !options.force) return;
        if (isAnimating) {
          queuedIndex = clamped;
          return;
        }

        // On first render we can snap immediately.
        if (options.immediate) {
          activeIndex = clamped;
          closeAllText();
          openTextAt(activeIndex);
          setMediaAt(activeIndex);
          updateControls(activeIndex);
          return;
        }

        isAnimating = true;
        updateControls(clamped);
        closeAllText();
        crossfadeMedia(activeIndex, clamped);

        window.setTimeout(() => {
          activeIndex = clamped;
          openTextAt(activeIndex);
          updateControls(activeIndex);
          isAnimating = false;

          if (queuedIndex !== null && queuedIndex !== activeIndex) {
            const nextQueued = queuedIndex;
            queuedIndex = null;
            setActive(nextQueued);
          } else {
            queuedIndex = null;
          }
        }, CLOSE_FIRST_DELAY_MS);
      };

      steps.forEach((step, index) => {
        step.addEventListener("click", () => setActive(index));
        step.addEventListener("keydown", (event) => {
          if (event.key !== "Enter" && event.key !== " ") return;
          event.preventDefault();
          setActive(index);
        });
      });

      if (prevBtn) prevBtn.addEventListener("click", () => setActive(activeIndex - 1));
      if (nextBtn) nextBtn.addEventListener("click", () => setActive(activeIndex + 1));

      setActive(activeIndex, { immediate: true, force: true });
    });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => initGuides(document));
  } else {
    initGuides(document);
  }

  document.addEventListener("shopify:section:load", (event) => initGuides(event.target));
})();
